import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  assetsList: [], 
  assetArr: [],
  assetArray: [],
  assetID: '',
  selectedAssignment: null,
  selectedAsset: null,
  selectedEmployee: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.assetsList = [];
    state.assetArr = [];
    state.assetArray = [];
    state.assetID = "";
    state.selectedAssignment = null;
    state.selectedAsset = null;
    state.selectedEmployee = null;
    state.isEditing = false;
  },
  SET_SELECTED_ASSIGNMENT(state, assignment) {
    state.selectedAssignment = assignment;
    state.isEditing = true;
  },
  LIST_ASSETS(state, Assets) {
    state.assetsList = Assets;
  },
  ASSETS_ARRAY(state, Assets){
    state.assetArray = Assets;
  },
  SET_SELECTED_ASSET(state, asset) {
    state.selectedAsset = asset;
  },
  SET_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createAssetAssignment({ commit,state }, formData) {
    return axios.post('api/v1/create-asset-assignment/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      throw error;
    })
  },

  fetchAssetAssignments({ commit,state }, formData) {
    state.assetArr = [];
    axios.post(`api/v1/get-asset-assignments/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.assetArr.push((response.data[i].employee.employee_name ));
      }
      commit('LIST_ASSETS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchAssetAssignment({ commit,state }, formData) {
    axios.post(`api/v1/get-asset-assignments/`,formData)
    .then((response)=>{
      state.selectedAssignment = response.data;
      const selectedEmployee = response.data.employee.staff_number + " - " + response.data.employee.employee_name;
      commit('SET_SELECTED_ASSET',response.data.asset.asset_name);
      commit('SET_SELECTED_EMPLOYEE', selectedEmployee);
      commit('SET_SELECTED_ASSIGNMENT', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedAssetAssignment({ commit, state }, option){
    const selectedAsset = state.assetsList.find(assignment => (assignment.employee.employee_name ) === option);
    if (selectedAsset) {
        state.assetID = selectedAsset.asset_assignment_id;
        state.assetArray = [...state.assetArray, selectedAsset];
    }
    commit('ASSETS_ARRAY', state.assetArray);
      
  },
  async updateAssetAssignment({ commit,state }, formData) {
    return axios.put(`api/v1/update-asset-assignment/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteAssetAssignment({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Assignment?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Assignment!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-asset-assignment/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Assignment removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Assignment",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Assignment has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  